import {
  Box,
  Typography,
  DialogContent,
  SelectChangeEvent,
  Drawer
} from '@mui/material';
import { useRef, useState, useContext, useEffect } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

// import * as Animatable from 'react-native-animatable';
import { TokenContext } from 'src/contexts/UserContext';
import { LoginObj, ResponseLogin } from 'src/models/login';
import Lottie, { useLottie } from 'lottie-react';
import logLocalIcon from '../../../../assets/icons/SIDEBAR/MODAL USUARIO-LOCAL_24X24.svg';
import DialogScreen from 'src/content/pages/Components/Dialog';
import ColorButtonStyleModal from 'src/content/pages/Components/ColorButton/ColorButtonStyleModal';
import iconSubirArchivo from '../../../../assets/imagen/SUBIR ARCHIVO_100X100.svg';
import iconEliminar from '../../../../assets/icons/MODAL/ELIMINAR_24X24.svg';
import groovyWalkAnimation from '../../../../assets/json_lottie/EXITO_600X600.json';
import jsonInfo from '../../../../assets/json_lottie/ALERTA_320X320.json';
import EstadoPill from 'src/content/pages/Components/Pill/EstadoPill';
import { styled } from '@material-ui/core';
import num1 from '../../../../assets/icons/NUMERACION 1_24X24.svg';
import num2 from '../../../../assets/icons/NUMERACION 2_24X24.svg';
import ButtonModify from 'src/content/pages/Components/ColorButton/ButtonModify';
import TextSelect from 'src/content/pages/Components/TextField/TextSelect';
import TablaCobranza from 'src/content/pages/Components/Table/TablaCobranza';
import TextFieldStyle from 'src/content/pages/Components/TextField/TextFieldStyle';
import {
  CertificadoDigital,
  CertificadoDigitalRespuesta
} from 'src/models/certificadoDigital';
import { postCertificadoB64 } from 'src/app/services/certificadoDigital.service';

interface Props {
  response: ResponseLogin;
  openDrawer?: boolean;
  setOpenDrawer?: (newValue: boolean) => void;
  datos: any[];
}

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});

const SuccesLottie = () => (
  <Lottie animationData={groovyWalkAnimation} loop={true} />
);
const InfoLottie = () => <Lottie animationData={jsonInfo} loop={true} />;

const DrawerCertificadoLocal = ({
  response,
  openDrawer,
  setOpenDrawer,
  datos
}: Props) => {
  const headCells: any = [
    {
      id: 'idlocal',
      numeric: false,
      disablePadding: false,
      label: 'ID LOCAL',
      width: '92px',
      widthXS: '92px',
      left: '0px 10px',
      visible: false
    },
    {
      id: 'ruc',
      numeric: true,
      disablePadding: true,
      label: 'RUC',
      width: '640px',
      widthXS: '592px',
      left: '0px 10px',
      visible: false
    },
    {
      id: 'codigolocal',
      numeric: true,
      disablePadding: true,
      label: 'Código',
      width: '92px',
      widthXS: '92px',
      left: '0px 10px',
      visible: true
    },
    {
      id: 'descripcion',
      numeric: true,
      disablePadding: false,
      label: 'Local',
      width: '268px',
      widthXS: '220px',
      left: '0px 10px',
      visible: true
    },
    {
      id: 'token',
      numeric: true,
      disablePadding: false,
      label: 'Token',
      width: '200px',
      widthXS: '200px',
      left: '0px 10px',
      visible: true
    },
    {
      id: 'urllogo',
      numeric: false,
      disablePadding: false,
      label: 'Logo',
      width: '80px',
      widthXS: '80px',
      left: '0px 10px',
      visible: true
    }
  ];
  const { idLoading, token } = useContext(TokenContext);
  // const [localesArray, setlocalesArray] = useState<Locales[]>([]);
  const [filtros, setfiltros] = useState([]);
  const [page, setPage] = useState(0);
  const [valuefilas, setvalueFilas] = useState(15);
  const [cantFiltrado, setcantiFiltrado] = useState(0);
  const [cantPage, setCantPage] = useState(0);
  const [selectedCount, setSelectedCount] = useState<number>(0);
  const [openModalSuccess, setopenModalSuccess] = useState(false);
  const usuario = response.name
    .toLowerCase()
    .trim()
    .split(' ')
    .map((v) => v[0].toUpperCase() + v.substr(1))
    .join(' ');
  const rol_user = response.role
    .toLowerCase()
    .trim()
    .split(' ')
    .map((v) => v[0].toUpperCase() + v.substr(1))
    .join(' ');
  const [estado, setEstado] = useState(response.certificado.estado);
  const [fVencimiento, setFVencimiento] = useState(
    response.certificado.fechavencimiento
  );
  const [valueTextSearch, setvalueTextSearch] = useState('');
  const [valuePinCertificado, setvaluePinCertificado] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [valueSearch, setValueSearch] = useState(0);
  const [openAlerta, setOpenAlerta] = useState(false);
  const [openModalInfo, setopenModalInfo] = useState(false);
  const [documentos, setDocumentos] = useState<CertificadoDigitalRespuesta[]>( []);
  const [detailRespuesta, setdetailRespuesta] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [nombreCertificado, setnombreCertificado] = useState('');
  const [base64String, setBase64String] = useState('');
  const fileInputRef = useRef(null);
  const [openlogo, setopenlogo] = useState(false);
  const { t } = useTranslation();

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const base64 = event.target.result as string;
      setBase64String(base64);
      setnombreCertificado(file.name);
    };
    reader.readAsDataURL(file);
  };

  const clearFileInput = () => {
    setBase64String('');
    setnombreCertificado('');

    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Limpiar el valor del input
    }
  };
  const handleCancelar = () => {
    clearFileInput();
    setvaluePinCertificado('');
    setOpenDialog(false);
  };

  const consultaDoc: CertificadoDigital = {
    certificadoBase64: base64String.split('base64,', 2)[1],
    // certificadoBase64: 'MIITngIBAzCCE2gGCSqGSIb3DQEHAaCCE1kEghNVMIITUTCCDc8GCSqGSIb3DQEHBqCCDcAwgg28AgEAMIINtQYJKoZIhvcNAQcBMBwGCiqGSIb3DQEMAQYwDgQIGvSIGSfgRxMCAggAgIINiHFcwBeojJ83B2Eln0iLRO75OoLEKhhwEkDeX4oN3VNbkgjBKNBtW85NfIQZda/KgpfHVzp+tjOCC+PHZ2zHQ1QAfYn1jqedFPIwpACPdFTtsOpF+l2Cs2wsVif0aMwp6SEIDi8g//8o9eB8epBiF8Gn0sk5p3nRJlGceHFLOwuuw3bz/j8ZdTR3dzUtPPibINZLBmdIt8YVE0FQaWii7Gi0bo8P/cAebv3gFhDCkk1UbaFqXasSejYUdJe8C/K4sjx+XgjvUubPV5rFenq+7gjH5UbQBQ5AIW5gG/9nENgIreRoV8tQLCjG2Ls+WCJfimA8tglKC33igBhZfcHkXfq6AnWcdqMSxZS8e4AA9OVIEvGFVIuyxXwhnXU3g0czuyGK95AsL1xtRrWve5q6fj0ycSO2i/GuhWnvsvyIyaeQhf+C95qgCs4ayw6sMu7u5CHkJflgWPD4L3fAmaujKkJP41s/WtSkgQpYdURbRfnp7XfBzCxe/nmFC4oCk8bHAzZOumB2C8JySNUYHLp3HUNisAHLaCGUWYNjaVB/270z/jNhJ35Znq2H+Ehv6tkFKuRJCJivXq5TnjWQ8xgboiT7Xh5Lzc2vr/7QdlMSskGJMUMZXbYLm2/ETMya/06yIuZ9JQtkOF1cBQKEWRAKCQuKYMEad7QsiKWzpn/gk8A1CQJsrZtfTFzXUmA4fFRKeZDqq3B4/TW8nLz6/fwWSvCsjr0rjVTsX8s8LNI2+piqilqDdPydQ131K1Hf74/SNy900Gmky19oKjx53RfXgfOnMBosxRpUk25T+LO6pIbDbdmVStIMzspvJQd95jxw8u7w+QEM3QXTg74FHHyl/0xDCyewyTiXT4QV/CyVj3M+6Rbd5rAFNLj7OBcTLEp+tfLkAlglu0j2TY4JV3sHDv8h9j2GjBIuB+XNfLoToXnwA39KYjHtOaxEoL4iCIcinWyk/waCXhszL7eZus5BcMyLXmmTYU8VwAxLJnenLZl2yv46OGPxiBG6N1v/ViFAVoYXrcNk56oc4Q0FkdnkqX1+3nP1ykopIW+h4pJ7WO43yuLEtVINPBHbjQWTF88Jh1gfcwcxdp/ajuGoYR1NXY82HHX9zmR5m7THkHA2TwVIx5DWxYsTQk81JlhB3zyIeA8yzAGyP5tLMZIBFdNIIjot79UPb9eJjcnFEkWi2qT6ek9Qco7bGYwsh41H3xGaVt7SHdkzQXXPrnT0MRhUQQsHCBXsJGocQZ+CbwEB82HDBoo1Kn7CknpIsEw9c40vspjnOyY6KRzZH/9Z3edYIcQnqE0zl0n+S0qL60c5Jbp1vxN5lNb0OsHbswaQhE1003gQClSwvJ79PkGpWGNShWvXT7RE0bYiJlZgpQUATHod/bu2IefjxkXvRxJQSXtK8AS6h0AEadg2+l+P2ZvWSLRRo+rnAbQP0LpJ59HWunAJ1kM9gRhxChH12s3Z3K5aITGEHU0Iefi4fa8xAa9O5ypl5XUGykKIfhiBOly0TGwGdHRspXEcc7oxAnr5Qym3jsb6RL+DKmgwcINN43fl6B5ncSAbU2KIgdwkPqRSf7enxj8iPHzXBG8v//qWpVBuCHNfDKP3kQg7LRfTAEmRuJRLpoJnce0VeQBWcw5T5ok4xVhFfq3jux2CTDxXhLnl63rVsb/3bhnD/SW8PgiEmIY+LvzMZ7ja82tQl40VZ/jJE/m9Bn9OOb09BWWBOcEvtUytaar3cM4UnVkTh5B2H83FMwjzVqWM+pwEFlV4dBWoaaYQBuLUhjB63XXZSBAQERo6Ku1qWckCXHQEl+ngSWfbl0OVzh4x5g9SI8m1RnkmCaGRKtRoASVSVRy+Fl1FK1c6G4aEyzGq0D7DffrkvGhJzNdTbU832fIeBKnRFuDjRLsErEx3S1nHKb//nCbEsWcwciKUq7YUByn3Ha2u7pamBuuRnME3ZGe86uAGWHXwatjwvQMVt0ZfiFGIpfWGNRR7Q1aUlPo/VAIAEGnB3k52X6HnUxf/T9bLYUtXu5BTXiioH9wYeLZaSmTsZvjqMHMY83Qbl+B6ZkOHO3ObYuVKub85W2ysJdeLvLTCU/h9NVJMcb0kxasYEIC3HcnboJhsySv0buK8E+BsOzro/44OPj6s3s9mbWhcU329dXO4WtFOeZbUMczRACt/ReGBegnrjLywaaZQixy+toKbVHBnYy06T17LyhJA0Df9snnq8YQKzIPbVZWESxgGtglu9pRp3ykUbEf7u7oU/HFBwvhYtat3Z+zcNbu9cOLsB72OaUa3mU3vq1BheC5RQ4MgcmpcIEI5giYioXYua5lYHca4Ze9OHzi0tXOvbn7BEeAVasIURLCVHWSk22ZNUMeaHyFssxGf35H6FqPBX63KJkv3Chf4cKgrF0BlN1o2uG30ITgTm0o9R8KzlV+Qgce4ny0RzZ1+e9lZjIa3r1asMIjPQdovQV0wcUSAZudTLmlzUnnv3qjjAGan95Hk7Kk/Btev6ZLU4zwqHj/wu/D3061kADB3nSgpojORSs5NBVASZbRIiiCZmdqssUydt8BH9u6hgW9Zi/A88APAZUVS0Bq0nz1DqPFP+Uo1idUuaYPG1zMjHjxrTKo9lfAeTw8Y4efmW/UZbtq27nYHFTnr8XslFzAhT4x8NvJ3FSHmk6OADWSNtECJaDn94ner3Q/qqkPpNpLI0DQ6mntbKJZ7GPGgD7pCc9DtHraKD87GiZfr1CQDmRjsIjM+vA+VRh49BD3XqpNaV9T2OEUecoN6cT/0xnOhmXdXa5k1y6AooCPVDYFceAS0Lr8PvAy2YJQZ5g9kqfEnGJpOAwPzFXWsibrIB5478GLta+wWoJ+/GpkDSnozYhC+mpPXwefca3bnTtw/j13XxN5WzRsZpvKlw1z+afp4+EZWyCywyqzGQVbaXaGNVhQaucyPYH8N5fi6vwTZbgVY7MfUg683kUHzPtXl0KLhCRNkBhvRQaYvxTzvxuKwheM7I7ZzQ5GlXpTp9cojUkD5T8G+QRi75GSJZl0OmYb8q9KHHn8hQx/+9oR+uPtbyIV1DNkkAJdWc4nIJ1vp3+VUJDyj+3uSM4gFbtAqIugWPTnsH7nxHH4CKFIWv6Drfrvydo8bm6+zbALcMWR7hQxSly4bKL5SRmEcJxVxG7tpp8aPLXjl2H0B97aBYzKTZMgp0FFb5jUB5mc1FdAN5E6h0vFqD/X25RI+3d8GnY81BbMiuCOt7T6Zx7KBF5Up53vCqhMHzgHdKsO6Ub1jmiZjq5gRbRF/RasXVl0AKsxd9N4epPsHW0iranSjq3BKziQUQmSlATISBqWxei4UaaK9v5Gc+rlA0z0rMYoy2LYRazp5aJYqjDrhwXmp26FBmuJoIGEd+HHgGdyrt32AcIjspSqof0r9a09oQIrCozgK2WF4KL2+COCzxICgtU+2lVIsa/ANk0KFKnyGgxM6k9yDYlwgif92E3fIOB9TL9rquayfXJ0LkjHhD5flc1eRbOV6b9oCWJ2aUEvHQ9FpPqbyiI5BXukvgxbBMLQIYPv+hUGZ/0uzKZOYIjHzbmI8i5PY2wTN1om/v2N0nNSVNohxWGSRk343kR7sNpl/09ZaWQrFtb/M58pLzZhv4uckyvPPIdJ37bRvCq42iKgAa1vWvLjTAHC3ejVFMCUpHNsxvPnvQLRz+6rppNrmZ67EtFvg0VHDcWKtyg9m/TFx+OhLv+4Tbj8BFYSi0SP7vv1Tfd0F9s1I4abGhkLcLPigJOt09EYn2qcl9oMj1h0mpRO9IRNJR2LixSirorgq3OGNoZEDgtENOhW9ps7xsFj9SgV97afi8f4kApEnOuEBuCBn7i8VFK/852KU79T1XXb62xnrUw+PKQ3VGvY5ZWNXCUn8oRLSHW4Prk71aQc9PRnsAfoVZoSmlCxmPymWzzUoU0ALZ9cRAYUFL2tWQX20nxoPAyL5Bn7FNqptvEdBYD4MADvk8is4DkpNPS+dQyAvEZDP1hPzvh1z/tj61uzbdK2MYShOKBaOORGqh+JKWB0x09IuQkWPNCfIz0VyrjILXaWWwSwcz7Xxk5cN4dxe08G2IaMQ3aJpPLhVTBsyhWfChSdJL9n8H99e+tEoIT2GyNLSjrNlVpKR20Z0hLm9kLAcrttOpO7Yw8/hTMTpcKQmOLXrT5ctjBC66Kxm2hQXwLSYALsBQJgFlLfmnv363kVraYRwDeYWe2GJsfHRTnZBbtgxkUqGj1wtGuxeuhEaVMFv5OtU0SfeXmtJV1BiwJkcp3U9DReNYgV2EIVP7aI+aJ/AGzNf/6XO1HepLIRXWeXyuBT9hutbSosAounAGpeHTyspEvA1shby9XUaiE+jg5/KL1auPboXlv/rQMzYBrkpRofVPo/BZ21NOhIw0rhTFB1DZgn17roL6kTLHHRqeP/DjjeDAcIE+U/lifo9b+sJTss0UIVKOld1xnt6YjlPnDNBeV3YKAQcGk2InUxkTcmFkC43rIxtxQeKDdLtp2Q/OOI5HL/QMlL/0PCmDo29eP616OLBmXH/kOES1J8Zzyp/nm7lPQ+tEhFUejY0YXPoQ5NvadsCpt2W59AJBOyD8kLn9f1oGXo0B7O/Z9VaanqJMIIFegYJKoZIhvcNAQcBoIIFawSCBWcwggVjMIIFXwYLKoZIhvcNAQwKAQKgggTuMIIE6jAcBgoqhkiG9w0BDAEDMA4ECMpmIJq5MjaxAgIIAASCBMgSw6bwGX9MwK4NQmchDaYCS7ZQgHl3ZyyIFimmdiUMdHhRp5g23eeeqvsYQGWEsSPGi09x5VkLcyY/8tJT0F2QiuFona6t0letuXUQYM59suPPZ2cPabkmwutIWjKBaBWMPb4Ul0pavMPqO0Ciz/1bHUFrk1qkQHrPsWhJ/HSC3LmVevnNSWkh+vwC3cTCqZMAcUMMHQTAzYJ99zq17meoEbXJHagBxj3oUkBvxDXCnJsCcqYR1gNO6KM5Zju3tDiw34HgTWrt0fOXej8g7SaRywEu6hTW9nNV0+OcK364wEZA4l79D1e+FSTpK9s101cGngqpZo7O8JsKeyFTPqrxK5VldRYnlaIEpsjslsOdZRGmviH/GxLABatG9KsyrDsz7zIgy5oQbajrTUtwddLCUlT+iM0tS3xfooBlYcb6BIPBKDW8TrYV1bHOhnC4FbkKTetDFv1roxMLX/6n3KixK++HOVvHj51t99TifPfTSyjcYjxmV1+0cwHjAbbrC40rEi2xzk7QNcqUzvwHi500+nyG+lCD7Ir11/JSBU4whnaOxsr8lsvrUay5CDq5C1OMvVsJRzHKKeRSOr/ioc9mKVky+fSSzx9ucdgLt093oFwlH4sYgzqe4iDX5Ws/PhBNI/v1SIu1ep9sb9vBYEgg96gHkIC2mDyS+QVn+TFtX0AAkRPqoFzp+2xLPP4CTnn+Z4oqIg56Yzfl8jU6QdKf1Mw7O4xJPgzfPy9sjiOHM4pW8y4vKW+Rn3fD7jw/Eutk43OJe2+3kdZkRC4ZRYcjcfMdX0BKk6FS1jM1UaqSI0vyUC4F6aJlM9W7uAIdHVkWMALMQfM6AfjqBRpcCt0042jDBGiKYacFEhRC58ylWF+oKgTWPFqk0otXxfwhmSQwpwL6YJqifgt1+Gplr122nklYsXkYpIbsDUp7/PCMGVqqtgUcVp+syQOFIE/SEESbI3jpwQ0kikbGJshwBlYS5sF5bTYGCpbVksloXDXWk7NwnKWh2TTUIKfsfzcQzt1y2eOTeas3IZiIPYs8H1saX2dz9NrYxrWk2A+pdoHEA1t+8oJtzCAPvnzEHodmYs3lqs+kk80lt5CvRPiz3mtwM2H+I2s3lV17FC78NnBtl7E1e7v8dt/WVLLTMvZ1ZjZXlEvVhSh8EKL59tcb5C8bUKBA+j1hZzdFI7sxtxjOS9Kj8uIOUhTJ1pv6pEN2z6a2BoEjjrr1eEzMII7z1ZE1UiGJDWXa37m7UzPxwpbL1tMSWEA2idSrx+2HKXqkDLfm17pqYzfYv5cIGjOAvaeL52ZvsdfghBVmWZ+HU7SKvMAA8hgfPpIk66Z9SFeAvfKHHYdV9IgEjc9vM9aq6Cj4j0dfSN+IYbSpUv8rClFIynl3ZifI/rhZ1F6kDJ35XSoYvtAtvV4kvqpJOGj0Rij8Z/8eW+sklY+k8Aa2ZfVEfY3xVPxS95HU0L8S1vltBB7bcnwdZQ+gAEp46xSZeZnqfWlXZaA8Ii6Ue6OsSFqoViLOhpuO3eCs0a7N9faX1xo9rn7G7mwpN/XgfPKJeXHz1jOxMZqdV46sqt0nSHW+dU3ABJf04peYVphJBwwjdcqshXDNrQDam0jk4fwPQ+julL409EgTrx4xXjAjBgkqhkiG9w0BCRUxFgQU1osrC376x6wf/C+hkKGOYMXWBOYwNwYJKoZIhvcNAQkUMSoeKAAyADAANgAwADcAOAA1ADgANgA0ADEAXwAyADUANgA2ADcAMgAzADYwLTAhMAkGBSsOAwIaBQAEFOludKVPsdjvlQd8YiyJkZz8hrPvBAgVQPbVum78Ig==',
    passwordCertificado: valuePinCertificado
  };

  const handleLimpiarTodo = () => {
    setfiltros([]);
    setSearchTerm('');
    setvalueTextSearch('');
  };

  const handleClickAlerta = () => {
    setOpenAlerta(estado !== '0' ? true : false);
  };
  const [value, setValue] = useState('Dione');

  const handleChangeSelect = (event: SelectChangeEvent) => {
    setValueSearch(event.target.value as any);
  };

  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (name === 'buscador') {
      setvalueTextSearch(value);
      setSearchTerm(value);
    }
    if (name === 'pin') {
      setvaluePinCertificado(value);
    }
  };

  const fetchCertificadoDigital = async () => {
    try {
      idLoading(true);
      setDocumentos([]);
      console.log(consultaDoc, 'B64');
      const lstDocumentos = await postCertificadoB64(consultaDoc, token);
      if (lstDocumentos !== undefined) {
        console.log(lstDocumentos);
        if (lstDocumentos.status === 200) {
          idLoading(false);
          const documentosRecp: CertificadoDigitalRespuesta[] = JSON.parse(
            JSON.stringify(lstDocumentos!.data)
          );
          console.log(lstDocumentos, 'AXIOS RECP');
          console.log(documentosRecp, 'documentos RECEP');
          // console.log(lstDocumentos)
          if (documentosRecp['code'] === '1') {
            // actualizado
            setopenModalInfo(true);
            setvaluePinCertificado('');
            setdetailRespuesta(documentosRecp['message']);
          } else {
            setOpenDialog(false);
            setvaluePinCertificado('');
            setopenModalSuccess(true);
            clearFileInput();
            const responseModify = JSON.parse(
              localStorage.getItem('responseLogin')!
            );
            responseModify.code = response.code;
            responseModify.id = response.id;
            responseModify.username = response.username;
            responseModify.name = response.name;
            responseModify.role = response.role;
            responseModify.token = response.token;
            responseModify.empresa = response.empresa;
            responseModify.acceso = response.acceso;
            responseModify.certificado.estado =
              documentosRecp['Objeto']['Certificado']['Estado'];
            responseModify.certificado.fechavencimiento =
              documentosRecp['Objeto']['Certificado']['Fechavencimiento'];
            localStorage.setItem(
              'responseLogin',
              JSON.stringify(responseModify)
            );
            setEstado(responseModify.certificado.estado);
            setFVencimiento(responseModify.certificado.fechavencimiento);
            // console.log('entrooo', documentosRecp['code'], responseModify.certificado.estado)
          }
        }
        if (lstDocumentos.status !== 200) {
          idLoading(false);
          setopenModalInfo(true);
          // console.log(lstDocumentos, 'RESPUESTA')
          setdetailRespuesta(lstDocumentos.data.detail);
        }
      }
    } catch (error: any) {
      const response = error.message;
      setdetailRespuesta(response);
      console.log('fetchCertificadoDigital', response);
    }
  };

  const handleActualizaCertificado = () => {
    fetchCertificadoDigital();
  };
  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };
  const handleCerrarSuccess = () => {
    setopenModalSuccess(false);
    clearFileInput();
    setvaluePinCertificado('');
  };
  const handleCerrarInfo = () => {
    setopenModalInfo(false);
    clearFileInput();
    setvaluePinCertificado('');
  };
  useEffect(() => {
    window.addEventListener('load', handleClickAlerta);
    return () => {
      window.removeEventListener('load', handleClickAlerta);
    };
  });

  return (
    <>
      <Drawer anchor="right" open={openDrawer} onClose={handleDrawerClose}>
        <Box
          sx={{
            width: { xs: 360, sm: 640, md: 728 },
            padding: '28px 28px 24px 28px',
            boxShadow: '0px 4px 20px 0px rgba(30, 41, 71, 0.12)'
          }}
        >
          <Box>
            <Typography
              sx={{
                color: 'var(--texto-900-contraste, #61B09D)',
                /* MOVIL/CUERPO/PARRAFO B */
                fontFamily: 'Poppins',
                fontSize: '14px',
                fontStyle: 'normal',
                fontweight: 500,
                lineHeight: '20px'
              }}
            >
              {usuario != null || usuario != undefined ? usuario : 'usuario'} 
            </Typography>
            <Typography
              sx={{
                color: 'var(--color-neutral-600, #A7B1BF)',
                fontFamily: 'Montserrat',
                fontSize: '24px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '26px'
              }}
            >
              {response.empresa.id}
            </Typography>
            <Box
              sx={{
                display: {
                  xs: 'block',
                  sm: 'flex',
                  md: 'flex',
                  lg: 'flex',
                  xl: 'flex'
                },
                width: '100%',
                paddingTop: '12px'
              }}
            >
              <Box display={'block'}>
                <Box display={'flex'}>
                  <img />
                  <Typography
                    sx={{
                      /* MOVIL/CUERPO/PARRAFO */
                      fontFamily: 'Poppins',
                      fontSize: '14px',
                      fontStyle: 'normal',
                      fontWeight: 300,
                      lineHeight: '20px'
                    }}
                  >
                    Tu certificado digital se encuentra{' '}
                    {estado == '0'
                      ? 'vigente '
                      : estado == '1' || estado == '3'
                      ? 'por vencer '
                      : 'vencido '}
                  </Typography>
                </Box>
                <Box paddingTop={'10px'}>
                  {estado == '0' ? ( //ESTADO VIGENTE (VERDE)
                    <EstadoPill
                      title={'Vence el ' + fVencimiento.toString()}
                      bg="var(--color-marca-verde-200, #E7F9EF)"
                      color="#3CB473"
                      widthx="180px"
                      heightx="26px"
                    ></EstadoPill>
                  ) : estado == '1' || estado == '3' ? ( // ESTADO PROXIMO (AMBAR)
                    <EstadoPill
                      title={'Vence el ' + fVencimiento.toString()}
                      bg="var(--color-marca-mostaza-200, #FFF5F0)"
                      color="#FFA826"
                      widthx="180px"
                      heightx="26px"
                    ></EstadoPill>
                  ) : estado == '2' ? ( // ESTADO CRITICO (ROJO)
                    <EstadoPill
                      title={'Vence el ' + fVencimiento.toString()}
                      bg="var(--color-marca-rojo-200, #FFECEB)"
                      color="#FF655A"
                      widthx="180px"
                      heightx="26px"
                    ></EstadoPill>
                  ) : (
                    ''
                  )}
                </Box>
              </Box>
              <Box
                sx={{
                  width: {
                    xs: '100%',
                    sm: '220px',
                    md: '220px',
                    lg: '220px',
                    xl: '220px'
                  },
                  marginLeft: 'auto',
                  alignContent: 'end',
                  paddingTop: {
                    xs: '20px',
                    sm: '0px',
                    md: '0px',
                    lg: '0px',
                    xl: '0px'
                  }
                }}
              >
                <ButtonModify
                  handleEvent={
                    response.certificado.estado == '2' ||
                    response.certificado.estado == '3'
                      ? handleDialogOpen
                      : () => {}
                  }
                  // handleEvent={handleDialogOpen}
                  title={'¿Renovar certificado?'}
                  pasive={estado === '0' ? true : false}
                  imgIcon={false}
                  urlIcon={''}
                  txtActivo={'#FFF'}
                  txtPasivo={'#98ACB3'}
                  bgActivo={'#80CFBC'}
                  bgPasivo={'#F2F2F2'}
                  bgHover={'#69C4DE'}
                  bgBorder=""
                />
              </Box>
            </Box>
          </Box>
        </Box>
        {/* MIS LOCALES - TABLA */}
        <Box
          sx={{
            display: 'flex',
            padding: '24px 28px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '12px',
            width: { xs: 360, sm: 640, md: 728, lg: 728, xl: 728 }
          }}
        >
          <Box
            sx={{
              display: {
                xs: 'block',
                sm: 'flex',
                md: 'flex',
                lg: 'flex',
                xl: 'flex'
              },
              width: '100%',
            }}
          >
            <Box
              display={'flex'}
              sx={{
                width: '100%',
                alignItems: 'center',
                paddingBottom: {
                  xs: '8px',
                  sm: '0px',
                  md: '0px',
                  lg: '0px',
                  xl: '0px'
                },
                gap: '12px',

              }}
            >
              <Box
                component="img"
                src={logLocalIcon}
                sx={{
                  width: '24px',
                  height: '24px'
                }}
              />
              <Typography
                sx={{
                  pr: {
                    xs: '8px',
                    sm: '8px',
                    md: '12px',
                    lg: '12px',
                    xl: '12px'
                  },
                  color: 'var(--color-neutral-texto, #1E2947)',
                  fontFamily: 'Poppins',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: '16px'
                }}
              >
                Mis locales
              </Typography>
              <EstadoPill
                title={cantFiltrado + ' registros'}
                bg="var(--color-marca-verde-200, #E7F9EF)"
                color="#3CB473"
                widthx="95px"
                heightx="24px"
              />
            </Box>
            <Box
              sx={{
                marginLeft: 'auto',
                width: {
                  xs: '100%',
                  sm: '296px',
                  md: '320px',
                  lg: '320px',
                  xl: '320px'
                }
              }}
            >
              <TextSelect
                title="TODOS"
                pplaceholder="Buscar en la tabla"
                value={valueTextSearch}
                nameValue="buscador"
                type={'text'}
                valueSelect={valueSearch}
                nameValueSelect="selectBuscar"
                options={''}
                handleChangeInputValues={handleChangeInput}
                handleChangeSelect={handleChangeSelect}
                required
              />
            </Box>
          </Box>
          <Box width={'100%'}>
            <TablaCobranza
              datos={datos}
              page={page}
              rowsPerPage={valuefilas}
              setCantPage={setCantPage}
              headCells={headCells}
              selectedCount={selectedCount}
              setSelectedCount={setSelectedCount}
              menu="locales"
              filtros={filtros}
              searchTerm={searchTerm}
              selectSearch={''}
              options={''}
              setcantiFiltrado={setcantiFiltrado}
              handleLimpia={handleLimpiarTodo} // limpia todo
            />
          </Box>
        </Box>
        {/*  dialog Subir certificado digital  */}
        <DialogScreen
          open={openDialog}
          handleOpen={() => setOpenDialog(true)}
          handleClose={() => setOpenDialog(false)}
          paper={{
            sx: {
              borderRadius: '20px',
              minWidth: {
                xs: '320px',
                sm: '560px',
                md: '540px',
                lg: '540px',
                xl: '540px'
              },
              maxWidth: {
                xs: '320px',
                sm: '560px',
                md: '540px',
                lg: '540px',
                xl: '540px'
              },
              minHeight: {
                xs: '528px',
                sm: '508px',
                md: '576px',
                lg: '576px',
                xl: '576px'
              },
              maxHeight: {
                xs: '528px',
                sm: '508px',
                md: '576px',
                lg: '576px',
                xl: '576px'
              }
            }
          }}
          direction={'right'}
          contentOfDialog={
            <DialogContent
              sx={{
                padding: {
                  xs: '24px 20px',
                  sm: '24px 20px',
                  md: '28px',
                  lg: '40px 28px 24px 28px',
                  xl: '40px 28px 24px 28px'
                }
              }}
            >
              <Box width={'100%'}>
                <Typography
                  sx={{
                    color: 'var(--texto-900-contraste, #61B09D)',
                    fontFamily: 'Montserrat',
                    fontSize: {
                      xs: '20px',
                      sm: '20px',
                      md: '24px',
                      lg: '24px',
                      xl: '24px'
                    },
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: {
                      xs: '24px',
                      sm: '24px',
                      md: '28px',
                      lg: '28px',
                      xl: '28px'
                    },
                    pb: '24px'
                  }}
                >
                  Renueva tu certificado digital
                </Typography>
                <Box
                  alignSelf={'center'}
                  sx={{
                    display: 'flex',
                    paddingBottom: '16px'
                  }}
                >
                  <img
                    src={num1}
                    style={{ float: 'left', alignSelf: 'center' }}
                  />
                  <Typography
                    sx={{
                      color: 'var(--color-neutral-texto, #1E2947)',
                      fontFamily: 'Poppins',
                      fontSize: {
                        xs: '14px',
                        sm: '14px',
                        md: '16px',
                        lg: '16px',
                        xl: '16px'
                      },
                      fontStyle: 'normal',
                      fontWeight: 300,
                      pl: '12px',
                      lineHeight: {
                        xs: '20px',
                        sm: '20px',
                        md: '24px',
                        lg: '24px',
                        xl: '24px'
                      }
                    }}
                  >
                    Sube el certificado para validar su renovación.
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    height: {
                      xs: '192px',
                      sm: '192px',
                      md: '260px',
                      lg: '260px',
                      xl: '260px'
                    },
                    borderRadius: '8px',
                    border: '1px dashed var(--color-neutral-500, #CFD3D8)',
                    borderStyle: 'dashed'
                  }}
                >
                  <Box
                    sx={{
                      textAlign: '-webkit-right',
                      paddingTop: '20px',
                      paddingRight: '20px'
                    }}
                  >
                    <EstadoPill
                      title={'Formato: PFX'}
                      bg="#F5F6F7"
                      color="#88919E"
                      widthx="120PX"
                      heightx="26px"
                    ></EstadoPill>
                  </Box>
                  <Box textAlign={'center'}>
                    <Box>
                      <img src={iconSubirArchivo} />
                    </Box>
                    <Box>
                      <Typography
                        component="label"
                        role={undefined}
                        tabIndex={-1}
                        sx={{
                          color: 'var(--boton-800-primario, #80CFBC)',
                          textAlign: 'center',
                          fontFamily: 'Poppins',
                          fontSize: '16px',
                          fontStyle: 'normal',
                          fontWeight: 500,
                          lineHeight: '24px',
                          textDecorationLine: 'underline',
                          cursor: 'pointer'
                        }}
                      >
                        Sube tu archivo
                        <VisuallyHiddenInput
                          accept=".pfx"
                          type="file"
                          ref={fileInputRef}
                          onChange={handleFileInputChange}
                        />
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box
                  display={nombreCertificado !== '' ? 'flex' : 'none'}
                  sx={{ alignItems: 'center' }}
                >
                  <Typography
                    sx={{
                      overflow: 'hidden',
                      color: 'var(--boton-800-primario, #80CFBC)',
                      textOverflow: 'ellipsis',
                      /* MOVIL/CUERPO/parrafo bold sub */
                      fontFamily: 'Poppins',
                      fontSize: '14px',
                      fontStyle: 'normal',
                      fontWeight: 500,
                      lineHeight: '20px' /* 142.857% */,
                      textDecorationLine: 'underline'
                    }}
                  >
                    {nombreCertificado}
                  </Typography>
                  <img
                    src={iconEliminar}
                    onClick={clearFileInput}
                    style={{
                      marginLeft: 'auto',
                      cursor: 'pointer',
                      padding: '10px'
                    }}
                  />
                </Box>
                <Box
                  alignSelf={'center'}
                  sx={{
                    display: 'flex',
                    paddingBottom: '16px',
                    pt: nombreCertificado !== '' ? '0px' : '20px'
                  }}
                >
                  <img
                    src={num2}
                    style={{
                      float: 'left',
                      alignSelf: 'center',
                      paddingRight: '12px'
                    }}
                  />
                  <TextFieldStyle
                    key={0}
                    handleChangeInputValues={handleChangeInput}
                    label="PIN de seguridad"
                    title="Razón Soc000ial"
                    titleInput="Ingrese su PIN de seguridad"
                    nameValue={'pin'}
                    type={'text'}
                    required={true}
                    disabled={false}
                    value={valuePinCertificado}
                  />
                </Box>
              </Box>
              <Box display={'flex'} gap={1}>
                <ButtonModify
                  // handleEvent={() => setOpenDialog(false)}
                  handleEvent={handleCancelar}
                  title={'CANCELAR'}
                  pasive={true}
                  imgIcon={false}
                  urlIcon={''}
                  txtActivo={'#FFF'}
                  txtPasivo={'var(--boton-800-primario, #80CFBC)'}
                  bgActivo={'#ff'}
                  bgPasivo={'#fff'}
                  bgHover={'#fff'}
                  bgBorder={'#99D9C9'}
                />
                <ButtonModify
                  handleEvent={handleActualizaCertificado}
                  title={'ENVIAR'}
                  pasive={false}
                  imgIcon={false}
                  urlIcon={''}
                  txtActivo={'#FFF'}
                  txtPasivo={'#98ACB3'}
                  bgActivo={'#80CFBC'}
                  bgPasivo={'#F2F2F2'}
                  bgHover={'#69C4DE'}
                  bgBorder={'#99D9C9'}
                />
              </Box>
            </DialogContent>
          }
        />

        {/*  dialog aceptacion de certificado  */}
        <DialogScreen
          open={openModalSuccess}
          handleOpen={() => setopenModalSuccess(true)}
          handleClose={handleCerrarSuccess}
          paper={{
            sx: {
              borderRadius: '20px',
              minWidth: {
                xs: '320px',
                sm: '320px',
                md: '420px',
                lg: '420px',
                xl: '420px'
              },
              maxWidth: {
                xs: '320px',
                sm: '320px',
                md: '420px',
                lg: '420px',
                xl: '420px'
              },
              minHeight: {
                xs: '380px',
                sm: '380px',
                md: '404px',
                lg: '404px',
                xl: '404px'
              },
              maxHeight: {
                xs: '380px',
                sm: '380px',
                md: '404px',
                lg: '404px',
                xl: '404px'
              }
            }
          }}
          direction={'right'}
          contentOfDialog={
            <DialogContent
              sx={{
                padding: {
                  xs: '22px 20px',
                  sm: '22px 20px',
                  md: '28px',
                  lg: '28px',
                  xl: '28px'
                }
              }}
            >
              <Box
                width={'100%'}
                sx={{
                  textAlign: '-webkit-center'
                }}
              >
                <Box
                  sx={{
                    width: { xs: 140, sm: 140, md: 160, lg: 160, xl: 160 },
                    height: { xs: 140, sm: 140, md: 160, lg: 160, xl: 160 }
                  }}
                >
                  <SuccesLottie />
                </Box>
                <Typography
                  sx={{
                    color: 'var(--color-marca-verde-800, #42C67E)',
                    textAlign: 'center',
                    fontFamily: 'Montserrat',
                    fontSize: '24px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: '28px',
                    pt: '12px'
                  }}
                >
                  ¡Certificado renovado!
                </Typography>
                <Typography
                  sx={{
                    color: 'var(--color-neutral-texto, #1E2947)',
                    textAlign: 'center',
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: '24px',
                    paddingBottom: {
                      xs: '32px',
                      sm: '32px',
                      md: '40px',
                      lg: '40px',
                      xl: '40px'
                    },
                    pt: '4px'
                  }}
                >
                  Tu información fue validada correctamente y se realizó la
                  activación de tu certificado.
                </Typography>
                <Box
                  display={'flex'}
                  sx={{
                    width: {
                      xs: '220px',
                      sm: '220px',
                      md: '280px',
                      lg: '280px',
                      xl: '280px'
                    }
                  }}
                >
                  <ButtonModify
                    handleEvent={handleCerrarSuccess}
                    title={'ACEPTAR'}
                    pasive={false}
                    imgIcon={false}
                    urlIcon={''}
                    txtActivo={'#FFF'}
                    txtPasivo={'#98ACB3'}
                    bgActivo={'#80CFBC'}
                    bgPasivo={'#F2F2F2'}
                    bgHover={'#69C4DE'}
                    bgBorder={'#99D9C9'}
                  />
                </Box>
              </Box>
            </DialogContent>
          }
        />

        {/*  dialogo informativo de certificado  */}
        <DialogScreen
          open={openModalInfo}
          handleOpen={() => setopenModalInfo(true)}
          handleClose={handleCerrarInfo}
          paper={{
            sx: {
              borderRadius: '20px',
              minWidth: {
                xs: '320px',
                sm: '320px',
                md: '420px',
                lg: '420px',
                xl: '420px'
              },
              maxWidth: {
                xs: '320px',
                sm: '320px',
                md: '420px',
                lg: '420px',
                xl: '420px'
              },
              minHeight: {
                xs: '388px',
                sm: '388px',
                md: '444px',
                lg: '444px',
                xl: '444px'
              },
              maxHeight: {
                xs: '388px',
                sm: '388px',
                md: '444px',
                lg: '444px',
                xl: '444px'
              }
            }
          }}
          direction={'right'}
          contentOfDialog={
            <DialogContent
              sx={{
                padding: {
                  xs: '22px 20px',
                  sm: '22px 20px',
                  md: '28px',
                  lg: '28px',
                  xl: '28px'
                }
              }}
            >
              <Box
                width={'100%'}
                sx={{
                  textAlign: '-webkit-center'
                }}
              >
                <Box
                  sx={{
                    width: { xs: 120, sm: 120, md: 140, lg: 140, xl: 140 },
                    height: { xs: 120, sm: 120, md: 140, lg: 140, xl: 140 }
                  }}
                >
                  <InfoLottie />
                </Box>
                <Typography
                  sx={{
                    color: 'var(--color-marca-celeste-800, #30ADD2)',
                    textAlign: 'center',
                    /* MOVIL/TITULOS/H3 */
                    fontFamily: 'Montserrat',
                    fontSize: {
                      xs: '24px',
                      sm: '24px',
                      md: '36px',
                      lg: '36px',
                      xl: '36px'
                    },
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: {
                      xs: '28px',
                      sm: '28px',
                      md: '40px',
                      lg: '40px',
                      xl: '40px'
                    } /* 116.667% */,
                    pt: {
                      xs: '20px',
                      sm: '20px',
                      md: '24px',
                      lg: '24px',
                      xl: '24px'
                    }
                  }}
                >
                  ¡Ups!
                </Typography>
                <Typography
                  sx={{
                    color: 'var(--color-neutral-texto, #1E2947)',
                    textAlign: 'center',
                    /* DESKTOP/CUERPO/parrafo bold */
                    fontFamily: 'Poppins',
                    fontSize: {
                      xs: '16px',
                      sm: '16px',
                      md: '20px',
                      lg: '20px',
                      xl: '20px'
                    },
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: {
                      xs: '24px',
                      sm: '24px',
                      md: '28px',
                      lg: '28px',
                      xl: '28px'
                    },
                    pb: '8px'
                  }}
                >
                  Hubo un error en el envío
                </Typography>
                <Typography
                  sx={{
                    color: 'var(--color-neutral-texto, #1E2947)',
                    /* MOVIL/CUERPO/parrafo light */
                    fontFamily: 'Poppins',
                    fontSize: {
                      xs: '14px',
                      sm: '14px',
                      md: '16px',
                      lg: '16px',
                      xl: '16px'
                    },
                    fontStyle: 'normal',
                    fontWeight: 300,
                    lineHeight: {
                      xs: '20px',
                      sm: '20px',
                      md: '24px',
                      lg: '24px',
                      xl: '24px'
                    },
                    paddingBottom: {
                      xs: '32px',
                      sm: '32px',
                      md: '40px',
                      lg: '40px',
                      xl: '40px'
                    }
                  }}
                >
                  {detailRespuesta}
                </Typography>

                <Box
                  display={'flex'}
                  sx={{
                    width: {
                      xs: '220px',
                      sm: '220px',
                      md: '280px',
                      lg: '280px',
                      xl: '280px'
                    }
                  }}
                >
                  <ButtonModify
                    handleEvent={handleCerrarInfo}
                    title={'ACEPTAR'}
                    pasive={false}
                    imgIcon={false}
                    urlIcon={''}
                    txtActivo={'#FFF'}
                    txtPasivo={'#98ACB3'}
                    bgActivo={'#80CFBC'}
                    bgPasivo={'#F2F2F2'}
                    bgHover={'#69C4DE'}
                    bgBorder={'#99D9C9'}
                  />
                </Box>
              </Box>
            </DialogContent>
          }
        />
      </Drawer>
      {/* LOGO EN B64 */}
      <DialogScreen
        open={openlogo}
        handleOpen={() => setopenlogo(true)}
        handleClose={() => setopenlogo(false)}
        paper={{
          sx: {
            borderRadius: '20px',
            minWidth: {
              xs: '320px',
              sm: '560px',
              md: '560px',
              lg: '540px',
              xl: '540px'
            },
            maxWidth: {
              xs: '320px',
              sm: '560px',
              md: '560px',
              lg: '540px',
              xl: '540px'
            },
            minHeight: {
              xs: '528px',
              sm: '508px',
              md: '508px',
              lg: '580px',
              xl: '580px'
            },
            maxHeight: {
              xs: '528px',
              sm: '508px',
              md: '508px',
              lg: '580px',
              xl: '580px'
            }
          }
        }}
        direction={'down'}
        contentOfDialog={
          <DialogContent
            sx={{
              padding: {
                xs: '24px 20px',
                sm: '24px 20px',
                md: '28px',
                lg: '40px 32px 24px 32px',
                xl: '40px 32px 24px 32px'
              }
            }}
          >
            <Box>
              <Typography
                sx={{
                  color: 'var(--texto-900-contraste, #61B09D)',
                  /* DESKTOP/TITULOS/H4 */
                  fontFamily: 'Montserrat',
                  fontSize: {
                    xs: '20px',
                    sm: '20px',
                    md: '24px',
                    lg: '24px',
                    xl: '24px'
                  },
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: {
                    xs: '24px',
                    sm: '24px',
                    md: '28px',
                    lg: '28px',
                    xl: '28px'
                  }
                }}
              >
                Edita el logo del local
              </Typography>
              <Typography
                sx={{
                  color: 'var(--color-neutral-texto, #1E2947)',
                  fontFamily: 'Poppins',
                  fontSize: {
                    xs: '14px',
                    sm: '14px',
                    md: '16px',
                    lg: '16px',
                    xl: '16px'
                  },
                  fontStyle: 'normal',
                  fontWeight: 300,
                  lineHeight: {
                    xs: '20px',
                    sm: '20px',
                    md: '24px',
                    lg: '24px',
                    xl: '24px'
                  }
                }}
              >
                Sube tu imagen y verifica que se muestre correctamente.
              </Typography>
            </Box>
            <Box>
              <Box display={'flex'}>
                <Box
                  width={'100%'}
                  sx={{
                    pr: {
                      xs: '8px',
                      sm: '8px',
                      md: '16px',
                      lg: '16px',
                      xl: '16px'
                    }
                  }}
                >
                  <ColorButtonStyleModal
                    handleEvent={() => setopenlogo(false)}
                    title="SI, SALIR"
                    pasive={true}
                  />
                </Box>
                <Box width={'100%'}>
                  <ColorButtonStyleModal
                    handleEvent={() => setopenlogo(false)}
                    title="CANCELAR"
                    pasive={false}
                  />
                </Box>
              </Box>
            </Box>
          </DialogContent>
        }
      />
    </>
  );
};

export default DrawerCertificadoLocal;
